// import React, { useState, useEffect } from "react";

function About() {
  // const imageUrls = [
  //   "https://res.cloudinary.com/qaz2dc/image/upload/v1691114678/ucbraids/pictures/IMG-20230727-WA0014_ez4igd.jpg",
  //   "https://res.cloudinary.com/qaz2dc/image/upload/v1691114678/ucbraids/pictures/IMG-20230727-WA0009_elycoi.jpg",
  //   "https://res.cloudinary.com/qaz2dc/image/upload/v1691114677/ucbraids/pictures/IMG-20230727-WA0004_zipuwi.jpg",
  //   "https://res.cloudinary.com/qaz2dc/image/upload/v1691114677/ucbraids/pictures/IMG-20230727-WA0005_ww7tqx.jpg",
  //   "https://res.cloudinary.com/qaz2dc/image/upload/v1691114676/ucbraids/pictures/IMG-20230727-WA0001_r1ckze.jpg",
  // ];
  // const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // const nextSlide = () => {
  //   setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageUrls.length);
  // };
  // useEffect(() => {
  //   const intervalId = setInterval(nextSlide, 3000);

  //   // Clean up the interval when the component is unmounted
  //   return () => clearInterval(intervalId);
  // }, []);
  return (
    <main className="about">
      <div className="bg"></div>
      <div className="inner flex justify-center align-center">
        <div className="text">
          <h2>About Me</h2>
          <p>
            Hello!
            <br />
            <br />
            I’m Uche, a home-based hair braider now serving all ages in Utah and
            Salt Lake counties.
          </p>
          <p>
            I would love to beautify your hair to your expectations. I am
            available for home services at an extra cost.
          </p>
          <p>Contact me for more details.</p>
          <p>
            $20 deposit required to confirm your booking: this goes towards the
            total cost of your service.
            <br />
            All payments are to be made via ApplePay, Cash or Zelle.
          </p>
          <p>
            Deposit can be used to reschedule an appointment with 24 hour
            notice. If notice is not given, deposit is forfeited.
          </p>
          <p>
            Take a look at my{" "}
            <a
              href="https://www.instagram.com/ucbraids/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>{" "}
            page for more pictures of my work.
          </p>
          <p>
            Any styles you desire that is not on the service list, please
            contact me to inquire of the style and availability.
          </p>
          <p>
            Hair extensions are provided for specific styles.
            <br />
            Contact me for more details.
          </p>
          <p>
            Please come with your hair washed (blow-drying is not necessary). I
            look forward to working with you!
          </p>
        </div>
        {/* <div className="img">
          <img
            className="slideshow-image"
            src={imageUrls[currentImageIndex]}
            alt={`Slide ${currentImageIndex + 1}`}
          />
        </div> */}
      </div>
    </main>
  );
}

export default About;
